import {
	getTokenDefinition,
} from "./getTokenDefinition";

import type {
	Address,
	TokenName,
	ValidChainId,
} from "@bracket/chainography/types";


export const getTokenAddress = ( name: TokenName | Address, chainId: ValidChainId = 1  ): Address => {
	return getTokenDefinition(name, chainId).address;
}
